<template>
  <public-layout>
    <template slot="main">
      <div class="w-full flex flex-col min-h-full dark:bg-staticdarkblue-900">
        <div class="flex flex-grow items-center justify-center mt-10">
          <div class="w-full max-w-sm relative">
            <base-logo :filename="logo" alt="EdasNEO" class="mx-auto mb-6 w-logo brand"/>
              <div>
                <el-form class="px-4 sm:px-0" 
                  :model="form"
                  :rules="rules"
                  ref="ruleForm"
                  autocomplete="off"
                  >
                <base-password-form-item v-model="form.password" placeholder="Contraseña..." publicView>
                  <p class="text-sm mb-4 text-center text-secondary-600">
                    Introduzca su nueva contraseña.
                  </p>
                </base-password-form-item>
                <base-password-form-item v-model="form.repeatPassword" :password="form.password" name="repeatPassword" placeholder="Repetir Contraseña..." repeat publicView>
                </base-password-form-item>
                  <div class="flex items-center justify-end ">
                    <span class="block text-sm font-semibold text-staticprimary-800 dark:text-staticdarkblue-200 cursor-pointer hover:text-staticprimary"
                      @click="goLogin()"
                    >Volver a inicio de sesión</span>
                  </div>
                  <base-button
                    mode="staticprimary"
                    text="Resetear contraseña"
                    class="w-full mt-4"
                    type="submit"
                    :loading = "loader"
                    @click.prevent.stop="doReset('ruleForm')"
                  />
                </el-form>
              </div>
            <base-logo-partner
              class="mx-auto mb-6 mt-6 w-logozc brand"
              alt="ZeroComa"
              :filename="logoPartner"/>
          </div>
        </div>
      </div>
    </template>
  </public-layout>
</template>

<script>
import PublicLayout from '@/components/layout/PublicLayout.vue'
import { changePassword } from '@/services/auth/changePassword'

export default {
  components: { PublicLayout },
  name: 'login',
  data: function () {
    return {
      form: this.setResetForm(),
      isLogin: false,
      loader: false,
      token: null,
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'edasneowhite.webp'
      }
      return 'edasneo.webp'
    },
    logoPartner: function () {
      if (this.darkMode) {
        return 'logo-zc-dark.webp'
      }
      return 'logo-zc.webp'
    },
  },
  mounted: function () {
    this.$store.commit('app/resetHaderCoreFilters')
    this.token = this.$route.params.token
  },
  methods: {
    setResetForm: function () {
      return {
        password: '',
        repeatPassword: ''
      }
    },
    goLogin: function () {
      this.$router.push({ name: 'login' })
    },
    doLogin: async function () {
      if (this.login.email && this.login.password) {
        try {
          this.loader = true
          await this.$store.dispatch('auth/login', this.login)
        } catch (error) {
          if (error !== undefined && error.blnError) {
            this.doFeedback(error.msgError + ' [Código de error: ' + error.codError + ']')
          } else {
            this.doFeedback()
          }
        } finally {
          this.loader = false
        }
      } else {
        this.doFeedback('Usuario y/o contraseña incorrectos')
      }
    },
    doReset: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loader = true
            const response = await changePassword(this.form.password, this.token)
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Contraseña cambiada con éxito', 'success')
              this.$router.push({ name: 'login' })
            }
          } catch (error) {
            this.doFeedback(this.$i18n.t('feedback.error.general'))
          } finally {
            this.loader = false
          }
        } else {
          this.doFeedback('Las contraseñas no coinciden')
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.w-logozc {
  max-width: 180px;
}
.w-logo {
  max-width: 250px;
}
</style>
